/**
 * Company metrics — shared period/range identifiers.
 * Tab + metric lists now live in chartRegistry / metricRegistry.
 */

import { COMPANY_METRICS_TABS as REGISTRY_TABS } from "./chartRegistry";
import { METRIC_REGISTRY, buildEstimateFieldMap } from "./metricRegistry";

export const METRICS_PERIODS = ["quarter", "annual"];

export const METRICS_RANGES = ["1Y", "3Y", "5Y", "10Y", "Max"];

export const COMPANY_METRICS_TABS = REGISTRY_TABS;

/** @deprecated use getChartsForTab — kept for transitional imports */
export const FINANCIALS_METRICS = Object.values(METRIC_REGISTRY).filter((m) =>
  ["revenue", "gross_profit", "operating_income", "net_income", "eps_diluted", "ebitda"].includes(m.id),
);

/** @deprecated use getChartsForTab */
export const CASHFLOW_METRICS = Object.values(METRIC_REGISTRY).filter((m) =>
  ["operating_cash_flow", "capital_expenditure", "free_cash_flow", "fcf_margin", "fcf_per_share", "custom_fcf"].includes(m.id),
);

export const ESTIMATE_FIELD_MAP = buildEstimateFieldMap();
